var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    d: "M13.9999 9.63202C13.9999 11.558 12.4536 13.1182 10.5276 13.1251H10.5206H3.67951C1.7604 13.1251 0.193359 11.5718 0.193359 9.64583V9.63892C0.193359 9.63892 0.197501 6.58354 0.203024 5.04687C0.203714 4.75831 0.535071 4.59677 0.760808 4.77626C2.40102 6.07753 5.33422 8.45018 5.37081 8.48124C5.86094 8.87404 6.48224 9.09563 7.11734 9.09563C7.75244 9.09563 8.37373 8.87404 8.86387 8.47365C8.90045 8.44949 11.7681 6.14794 13.4331 4.82527C13.6596 4.6451 13.9923 4.80663 13.993 5.0945C13.9999 6.61943 13.9999 9.63202 13.9999 9.63202Z",
    fill: "#484848",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    d: "M13.6386 2.54466C13.0407 1.41805 11.8644 0.69873 10.5694 0.69873H3.6799C2.38485 0.69873 1.20853 1.41805 0.610707 2.54466C0.476783 2.79663 0.540293 3.11073 0.763269 3.28884L5.88895 7.38869C6.24792 7.67863 6.68282 7.8229 7.11773 7.8229C7.12049 7.8229 7.12256 7.8229 7.12463 7.8229C7.1267 7.8229 7.12946 7.8229 7.13153 7.8229C7.56644 7.8229 8.00135 7.67863 8.36032 7.38869L13.486 3.28884C13.709 3.11073 13.7725 2.79663 13.6386 2.54466Z",
    fill: "#484848",
    fillOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.812a9c7bc2c2ff09c63e3b2df9765134.svg";
export { ForwardRef as ReactComponent };